<script setup lang="ts">
import { computed } from "vue";
import { useGalleries } from "@/composables/useGalleries";
import type { MenuItem } from "primevue/menuitem";

const { galleries } = useGalleries();

function scrollToGallery(id: string) {
	const scrollContainer = document.querySelector(".p-scrollpanel-content");
	const target = document.getElementById(id);
	if (scrollContainer && target) {
		const containerRect = scrollContainer.getBoundingClientRect();
		const targetRect = target.getBoundingClientRect();
		scrollContainer.scrollTo({
			top: scrollContainer.scrollTop + targetRect.top - containerRect.top,
			behavior: "smooth"
		});
	}
}

const menuItems = computed<MenuItem[]>(() =>
	galleries.value.map((gallery) => ({
		label: gallery.banner.title,
		command: () => scrollToGallery(gallery.banner.id)
	}))
);
</script>

<template>
	<Menubar :model="menuItems" breakpoint="960px" class="m-2 border-none">
		<template #start>
			<div class="flex items-center gap-4">
				<span class="inline-flex items-center justify-center rounded-full bg-gray-950" style="min-width: 33px; min-height: 33px; width: 33px; height: 33px;">
					<img src="../assets/wsp-icon-w.png" alt="White Summer Photography Logo" />
				</span>
				<span class="font-semibold md:inline">WHITE SUMMER PHOTOGRAPHY</span>
			</div>
		</template>
		<template #end>
			<ButtonGroup>
				<Button
					as="a"
					icon="pi pi-instagram"
					href="https://www.instagram.com/whitesummerphotography"
					target="_blank"
					rel="noopener"
					plain
					text
				/>
				<Button
					as="a"
					icon="pi pi-facebook"
					href="https://www.facebook.com/whitesummerphotography1/?timeline_context_item_type=intro_card_work&timeline_context_item_source=1231073256&pnref=lhc"
					target="_blank"
					rel="noopener"
					plain
					text
				/>
			</ButtonGroup>
		</template>
	</Menubar>
</template>

<style scoped>
:deep(.p-menubar-button) {
	background: none !important;
	border: none !important;
}
</style>
